import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { ApplicantDetailListModel } from "src/app/model/ApplicantDetailListModel";
import { Page } from "src/app/model/Page";
import { ProApproverListModel } from "src/app/model/ProApproverListModel";
import { ProApproverService } from "src/app/services/pro-approver.service";

@Component({
  selector: "app-secure-applicant-approver-list",
  templateUrl: "./applicant-approver-list.component.html",
  styleUrls: ["./applicant-approver-list.component.scss"],
})
export class ApplicantApproverListComponent implements OnInit, AfterViewInit {
  pageList: Page<ApplicantDetailListModel>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<ApplicantDetailListModel> =
    new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "applicationNo",
    "type",
    "verificationDate",
    "status",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  verStatusList: string[] = ["PENDING", "APPROVED", "REJECTED"];

  constructor(
    private router: Router,
    private proApproverService: ProApproverService,
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.minLength(3)]),
      verificationStatus: new FormControl("PENDING", [Validators.required]),
    });
    this.loadData();
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.loadData();
    } else {
      this._snackBar.open("Please Select Verification Status", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  resetFilter() {
    this.filterForm.controls["filterText"].setValue(null);
    this.filterForm.controls["verificationStatus"].setValue("PENDING");
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.proApproverService
      .fetchApplicantApprovePendingList(
        this.currentPage,
        this.pageSize,
        this.filterForm.value?.filterText != undefined
          ? this.filterForm.value?.filterText
          : null,
        this.filterForm.value?.verificationStatus
      )
      .subscribe(
        (page) => {
          this.isLoading = false;
          console.log(page);
          this.pageList = page;
          this.dataSource = new MatTableDataSource(page.content);
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = page.totalElements;
          });
          this.isSearchDisabled = false;
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isSearchDisabled = false;
        }
      );
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  showVerificationStatus(o1: any, o2: any) {
    if (o1 && o2 && o1 == o2) {
      return o1;
    } else {
      return "";
    }
  }

  viewClassForVerificationStatus(moderationStatus: string) {
    if (moderationStatus === "PENDING") {
      return "bg-blue-400";
    } else if (moderationStatus === "APPROVED") {
      return "bg-green-400";
    } else if (moderationStatus === "REJECTED") {
      return "bg-pink-600";
    } else {
      return "";
    }
  }
}
